import React, { Component } from 'react';
import PropTypes from 'prop-types';

import LinearProgress from 'material-ui/LinearProgress';
import FlatButton from 'material-ui/FlatButton';
import EmailIcon from 'material-ui/svg-icons/content/mail';

import Fetcher from '../../util/fetcher';
import StepProps from '../../constants/StepProps';
import { alertDialog } from '../../util/dialogs';


const styles = {
  flexBox: {display:"flex", flexWrap: 'wrap', justifyContent: "space-between"},
  loadingTextDiv: {lineHeight: '36px'},
  emailButtonDiv: {marginLeft: 'auto'},
}

// TODO: Something in this component seems to be causing a warning in the React console.
// Warning: setState(...): Cannot update during an existing state transition 
class AmplificationStepProcessing extends Component {
  static contextTypes = {
    dataset: PropTypes.string.isRequired,
    firebaseToken: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  };

  static propTypes = StepProps;

  componentDidMount() {
    this.props.onValidationChange(false);
    this.pollStatus();
  }

  /**
   * Whenever an error occurs, notify the stepper component
   * @param {Object} error
   */
  processFailed = (error) => {
    const { onStepCompleteFailed } = this.props;
    this.props.onValidationChange(true);
    onStepCompleteFailed(error);
  }

  /**
   * Delayed call to amplify status poll
   *
   * @param {Object} response 
   */
  delayedPollStatus = (response) => {
    // Here we check if the pollStatus should be called again, or if we are finished:
    if (response && response.data && response.data.done) {
      this.processAmplificationCompleted();
    } else {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.pollStatus, 5000);
    }
  }

  /**
   * Handle email notification choice
   */
  handleNotifyRequest = () => {
    const { hash } = this.props;
    Fetcher.init(this.context.firebaseToken)
      .ampNotify(hash, this.context.dataset)
      .catch(this.processFailed)
      .then(() => {
        clearTimeout(this.timeout); // don't let it continue to poll
        alertDialog(
          "You'll now notified by email when your task is done. Feel free to start another task.",
          "OK",
          "Email notification"
        );
        this.context.history.push(`/amp/restart`);
      }); // TODO: point to feedback page instead
  }

  /**
   * When the load has succesfully completed, we should keep monitoring the BQ job that does the amplification.
   * We do this by polling.
   *
   * @param {Object} response 
   */
  pollStatus = () => {
    const { hash } = this.props;

    Fetcher.init(this.context.firebaseToken)
      .ampProcessStatus(hash, this.context.dataset)
      .then(this.delayedPollStatus)
      .catch(this.processFailed);
  }

  /**
   * When we are done with both the load and the amplification process, continue.
   */
  processAmplificationCompleted = () => {
    const { onValidationChange, onStepCompleteSuccess } = this.props;
    onValidationChange(true);
    onStepCompleteSuccess();
  }

  render() {
    return (
      <div>
        <br/>
        <div style={styles.flexBox}>
          <div style={styles.loadingTextDiv}>Your data is being processed. This could take several minutes.</div>
          <div style={styles.emailButtonDiv}>
            <FlatButton
              label="Email me when it's done"
              labelPosition="before"
              primary={true}
              onClick={this.handleNotifyRequest}
              icon={<EmailIcon />}
            />
          </div>
        </div>
        <LinearProgress mode="indeterminate" />
        <br/>
        <br/>
      </div>
    );
  }
}
export default AmplificationStepProcessing;



// WEBPACK FOOTER //
// ./src/components/AmpStepProcessing/index.jsx